import { render, staticRenderFns } from "./rankingBoard.vue?vue&type=template&id=9b934e1c&scoped=true"
import script from "./rankingBoard.vue?vue&type=script&lang=js"
export * from "./rankingBoard.vue?vue&type=script&lang=js"
import style0 from "./rankingBoard.vue?vue&type=style&index=0&id=9b934e1c&prod&lang=less"
import style1 from "./rankingBoard.vue?vue&type=style&index=1&id=9b934e1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b934e1c",
  null
  
)

export default component.exports